module.exports = __webpack_public_path__ + "fc8b597d445ed7a76b4c7a65dfa5765e.svg";